import { NoDocuments } from '@plato/ui-legacy/assets/icons/no-documents';
import { cn } from '@plato/ui/util/classes';
import { useTranslation } from 'react-i18next';

type Props = {
    className?: string;
};

export function InsightListEmpty({ className }: Props) {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'flex flex-row items-center rounded-md border border-neutral-200 py-2 bg-white xl:py-4',
                className,
            )}
        >
            <div className="">
                <NoDocuments />
            </div>
            <div className="flex flex-col">
                <div className="text-sm font-bold leading-6 text-neutral-700 xl:text-base">
                    {t('empty_state__title', { ns: 'insights' })}
                </div>
                <div className="text-sm font-normal leading-5 text-neutral-600 ">
                    {t('empty_state__body', { ns: 'insights' })}
                </div>
            </div>
        </div>
    );
}
